import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/forms";
import * as i3 from "../../../directives/icon/icon.directive";
import * as i4 from "../../../directives/popovers/tooltip/tooltip.directive";
function SimpleInputComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6);
    i0.ɵɵlistener("click", function SimpleInputComponent_div_3_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.clear()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 7);
    i0.ɵɵelementEnd()();
} }
function SimpleInputComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 8)(1, "div", 9);
    i0.ɵɵlistener("click", function SimpleInputComponent_span_4_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.submit()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.buttonText);
} }
export class SimpleInputComponent {
    constructor() {
        this.inputDisabled = false;
        this.isClearable = false;
        this.handler = new EventEmitter();
    }
    clear() {
        this.handler.emit('');
    }
    submit() {
        this.handler.emit(this.value);
    }
}
SimpleInputComponent.ɵfac = function SimpleInputComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SimpleInputComponent)(); };
SimpleInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SimpleInputComponent, selectors: [["ycn-simple-input"]], inputs: { value: "value", buttonText: "buttonText", inputDisabled: "inputDisabled", inputObject: "inputObject", isClearable: "isClearable", placeholder: "placeholder" }, outputs: { handler: "handler" }, standalone: false, decls: 5, vars: 5, consts: [[1, "input-group"], [1, "field-input-group", "input-group"], ["type", "text", 1, "form-control", "field-input", 3, "ngModelChange", "keydown.enter", "ngModel", "placeholder", "disabled"], ["class", "field-input-group-actions", 4, "ngIf"], ["class", "input-group-btn", 4, "ngIf"], [1, "field-input-group-actions"], ["ycnTooltip", "", "tooltipTitle", "Clear the Field", "tooltipPlacement", "bottom", 1, "btn", "btn-transparent", "btn-clear", 3, "click"], ["ycnIcon", "", "name", "icon-close"], [1, "input-group-btn"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"]], template: function SimpleInputComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "input", 2);
        i0.ɵɵtwoWayListener("ngModelChange", function SimpleInputComponent_Template_input_ngModelChange_2_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.value, $event) || (ctx.value = $event); return $event; });
        i0.ɵɵlistener("keydown.enter", function SimpleInputComponent_Template_input_keydown_enter_2_listener() { return ctx.submit(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, SimpleInputComponent_div_3_Template, 3, 0, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, SimpleInputComponent_span_4_Template, 3, 1, "span", 4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtwoWayProperty("ngModel", ctx.value);
        i0.ɵɵproperty("placeholder", ctx.placeholder)("disabled", ctx.inputDisabled);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.value && ctx.isClearable);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.buttonText);
    } }, dependencies: [i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, i3.IconDirective, i4.TooltipDirective], encapsulation: 2 });
